// External libraries
import * as React from "react";

// TYpes
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { HotelsFTNode } from "components/flexComponents/Hotels/typings";
import { HotelsFlexModuleResult } from "src/typings/microserviceModels/hotels-flex-module";

export const HotelsContext = React.createContext<{
  flexTemplateNode?: HotelsFTNode;
  model?: HotelsFlexModuleResult;
  context?: ExtendedContextStore;
}>({});

export function useHotelsContext() {
  const { flexTemplateNode, context, model } = React.useContext(HotelsContext);

  if (!flexTemplateNode) {
    throw new Error("flexTemplateNode not provided");
  }

  if (!model) {
    throw new Error("model not provided");
  }

  if (!context) {
    throw new Error("context not provided");
  }

  return { flexTemplateNode, context, model };
}
